// Inline SVG (no hosted S3 asset), same pattern as FetchFailureIcon.tsx — the real Figma
// `file_open` export at its native 20x20. The mask and white hairline strokes are the export's
// own; don't simplify them.
//
// #545B62 is the design's own grey — deliberately NOT the row's purple (that belongs to the
// filename text beside it). Fills stay `currentColor` so the grey lives in CSS (`.FileIcon`'s
// `color`) — one override point.
//
// aria-hidden because the adjacent filename text is the accessible name; an aria-label here
// would double-announce it.
const SourceFileIcon = ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <mask id="mask0_35695_20841" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
            <rect x="0.105" y="0.105" width="19.79" height="19.79" fill="#D9D9D9" stroke="white" strokeWidth="0.21" />
        </mask>
        <g mask="url(#mask0_35695_20841)">
            <path
                d="M15.0215 13.6055V15.0615H17.0449L16.8662 15.2412L14.4814 17.625L15.501 18.6631L18.0635 16.1006V18.1035H19.5195V13.6055H15.0215Z"
                fill="currentColor"
                stroke="white"
                strokeWidth="0.21"
            />
            <path
                d="M5.00031 1.77148H11.6234L16.5618 6.70996V11.5605H15.1048V7.39453H10.9388V3.22754H4.89484V16.7715H12.3948V18.2275H5.00031C4.57004 18.2275 4.20364 18.0754 3.89679 17.7686C3.59015 17.4618 3.43878 17.0961 3.43878 16.666V3.33301C3.43878 2.90274 3.58993 2.53635 3.89679 2.22949C4.20364 1.92264 4.57004 1.77148 5.00031 1.77148Z"
                fill="currentColor"
                stroke="white"
                strokeWidth="0.21"
            />
            <path
                d="M7.06702 11.7715H12.4C12.549 11.7715 12.6922 11.8312 12.7975 11.9365C12.9025 12.0417 12.9615 12.1843 12.9615 12.333C12.9615 12.4819 12.9027 12.6252 12.7975 12.7305C12.6922 12.8358 12.549 12.8945 12.4 12.8945H7.06702C6.91805 12.8945 6.77489 12.8358 6.66956 12.7305C6.56422 12.6251 6.50549 12.482 6.50549 12.333C6.50558 12.1842 6.5644 12.0418 6.66956 11.9365C6.77489 11.8312 6.91805 11.7715 7.06702 11.7715ZM7.06702 9.10547H12.4C12.549 9.10547 12.6922 9.1642 12.7975 9.26953C12.9027 9.37485 12.9615 9.51811 12.9615 9.66699C12.9615 9.81568 12.9025 9.95825 12.7975 10.0635C12.6922 10.1688 12.549 10.2285 12.4 10.2285H7.06702C6.91805 10.2285 6.77489 10.1688 6.66956 10.0635C6.5644 9.95824 6.50558 9.81576 6.50549 9.66699C6.50549 9.51803 6.56422 9.37486 6.66956 9.26953C6.77489 9.1642 6.91805 9.10547 7.06702 9.10547Z"
                fill="currentColor"
                stroke="white"
                strokeWidth="0.21"
            />
        </g>
    </svg>
);

export default SourceFileIcon;
